<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("company") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text style="height: 250px;">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="companyName"
                                    :label="`${$t('companyName')} *`"
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-select
                                    v-model="subscription"
                                    :items="subscriptions"
                                    item-text="title"
                                    item-value="id"
                                    :label="`${$t('subscriptionLevel')} *`"
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-menu
                                    v-model="datePicker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="expiredDate"
                                        :label="`${$t('subscriptionExpiredDate')} *`"
                                        prepend-icon="event"
                                        readonly
                                        required
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="expiredDate"
                                        @input="datePicker = false"
                                        :locale="this.$i18n.locale"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <small>{{ $t("requiredFieldPointer") }}</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="saveDataClick">{{ $t("save") }}</v-btn>
                    <v-btn color="error" @click="dialog = false">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "EditCompanyDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog: false,
                dataUpdated: false,
                companyId: 0,
                companyName: "",
                datePicker: false,
                expiredDate: "",
                subscription: "",
                subscriptions: [],
                /*
                subscriptions: [
                    { id: 1, title: "Ознакомительный" },
                    { id: 2, title: "Эконом" },
                    { id: 3, title: "Для средних предприятий" },
                    { id: 4, title: "Многопользовательская" },
                    { id: 5, title: "Профессиональная" },
                    { id: 6, title: "Холдинг" }
                ]
                */
            }
        },

        mounted () {
            this.applyLocale();
        },

        watch: {
            /* При показе формы сбрасываем флаг изменения данных */
            dialog: function (val) {
                if (val) { this.dataUpdated = false; }
            }
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                /*
                this.subscriptions = [
                    { id: 1, title: this.$t("subscriptionLevel1") },
                    { id: 2, title: this.$t("subscriptionLevel2") },
                    { id: 3, title: this.$t("subscriptionLevel3") },
                    { id: 4, title: this.$t("subscriptionLevel4") },
                    { id: 5, title: this.$t("subscriptionLevel5") },
                    { id: 6, title: this.$t("subscriptionLevel6") }
                ];
                */
            },

            /**
             * Сброс значений полей формы
             */
            resetForm () {
                this.dataUpdated  = false;
                this.companyId    = 0;
                this.companyName  = "";
                this.expiredDate  = "";
                this.subscription = "";
            },

            /**
             * Сохранение данных новой компании
             */
            saveData () {
                let level = 1;
                this.subscriptions.forEach((item) => {
                    if (item.title == this.subscription) {
                        level = item.id;
                    }
                });

                //this.axios.post(${this.$config.apiURL} + "companies/", { withCredentials: true })
                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}companies/`,
                    data: {
                        name:            this.companyName,
                        subscription_id: level,
                        expired:         this.expiredDate + " 23:59:59"
                    },
                    withCredentials: true
                }).then(response => {
                    // console.log("response", response);
                    if (response.data.status == "success") {
                        this.showMessageBox(this.$t("information"), this.$t("companyCreated"));
                        this.dataUpdated = true;
                    } else {
                        if (response.data.result == "company_already_exists") {
                            this.showMessageBox(this.$t("error"), this.$t("companyAlreadyRegistered"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantCreateCompany"));
                        }
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) {
                            this.dialogWatcher();
                        }

                        /* Отслеживание ответа в диалоге "Да/Нет" */
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => {
                                window.location.reload();
                            }
                        );
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantCreateCompany"));
                    }
                });

                this.dialog = false;
            },

            /**
             * Обработчик нажатия кнопки сохранения
             */
            saveDataClick () {
                if (this.companyId == 0) {
                    this.saveData();
                } else {
                    this.updateData();
                }
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Обновление данных существующей компании
             */
            updateData () {
                /*
                let level = 1;
                this.subscriptions.forEach((item) => {
                    if (item.title == this.subscription) {
                        level = item.id;
                    }
                });
                */

                //this.axios.post(${this.$config.apiURL} + "companies/", { withCredentials: true })
                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}companies/${this.companyId}/`,
                    data: {
                        name:            this.companyName,
                        subscription_id: this.subscription, //level,
                        expired:         this.expiredDate + " 23:59:59"
                    },
                    withCredentials: true
                }).then(() => {
                    //this.showMessageBox(this.$t("information"), this.$t("companyUpdated"));
                    this.dataUpdated = true;
                }).catch(err => {
                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateCompany"));

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `EditCompanyDialog.vue -> updateData: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });
                });

                this.dialog = false;
            }
        }
    }
</script>
